// extracted by mini-css-extract-plugin
export default {"text":"InfoItem_text__8F7vy","container":"InfoItem_container__UYLEs"};